// extracted by mini-css-extract-plugin
export default {"avatar":"_67SRP7JnqhpARnvRZmn7iQ==","avatar-content":"iI7NvB70pF9odFgOJ9tBOg=="};